import { SingleInputConnectIntegrationFormDrawerContent } from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent/SingleInputConnectIntegrationFormDrawerContent';
import { GetAddIntegrationFormDrawerContentProps } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { useState } from 'react';

export const G2FormDrawerContent = ({
  integrationType,
  integrationChannel,
  onDrawerClose,
}: GetAddIntegrationFormDrawerContentProps) => {
  const [G2Url, setG2Url] = useState('');

  return (
    <SingleInputConnectIntegrationFormDrawerContent
      inputFieldData={G2Url}
      setInputFieldData={setG2Url}
      integrationChannel={integrationChannel}
      integrationType={integrationType}
      integrationData={{
        g2: {
          slug: G2Url,
        },
      }}
      textFieldProps={{
        label: 'G2 URL',
        placeholder: 'Enter G2 URL',
      }}
      onDrawerClose={onDrawerClose}
    />
  );
};
